import CONSTANTS from 'common/signature-modal/constants';
import signatureModalContext from 'common/signature-modal/context';
import SignatureProviderImpl from 'common/signature-modal/signature-provider-impl';

import SignatureModal from './signature-modal';
import { withSignatureModalContextProvider } from './contexts/signature-modal';
import { withCanvasContextProvider } from './contexts/canvas';

export { CONSTANTS, signatureModalContext, SignatureProviderImpl };

export default (
  withCanvasContextProvider(
    withSignatureModalContextProvider(
      SignatureModal,
    ),
  )
);
